/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import MembreCard from "../MembreCard/MembreCard";
import axios from "axios";
import { Paginator } from "primereact/paginator";
import "../../../Pagination/Pagination.scss";
import { InputText } from "primereact/inputtext";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import { Dropdown } from "primereact/dropdown";
import { connect } from "react-redux";
import "./contributeurs.scss";
import PropTypes from "prop-types";
import { updateAdmin } from "Redux/Actions/adminActions";
import { BsCloudHail } from "react-icons/bs";

const Contributeurs = (props) => {
  const containerRef = useRef(null);
  const [surname, setSurname] = useState("");
  const [firstname, setFirstname] = useState("");
  const [roleToFind, setRoleToFind] = useState({});
  const [users, setUsers] = useState([]);
  const [usersFiltered, setUsersFiltered] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  useEffect(() => {
    handleGetUsers();
  }, []);
  const handleGetUsers = () => {
    //?On ajoute les critères de validateurs et contributeurs à l'url
    axios
      .get(`${process.env.REACT_APP_BASE_URL_API}/users/contributors`, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((response) => {
        setUsers(Object.values(response.data));
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };
  const handleRecherche = () => {
    if (roleToFind.code !== "") {
      switch (roleToFind.code) {
        case "VALIDATEUR_OFFRE":
          setIsFiltered(true);
          //TODO Réaliser l'appel API avec le filtre validateur offre quand le back sera fait
          break;
        case "REDACTEUR_ACTUS":
          setIsFiltered(true);
          //TODO Réaliser l'appel API avec le filtre rédacteur actu quand le back sera fait
          break;
        default:
          setIsFiltered(false);
          setUsersFiltered(users);
          break;
      }
    }
  };

  const rolesData = [
    { name: "Tous", code: "tous" },
    { name: "Valider les offres", code: "VALIDATEUR_OFFRE" },
    { name: "Rédiger les actus", code: "REDACTEUR_ACTUS" },
  ];

  const onBasicPageChange = (event) => {
    props.handleUpdatePagination({ currentPage: event.page + 1 });
    props.handleUpdatePagination({ paginationBasicFirst: event.first });
    props.handleUpdatePagination({ paginationBasicRows: event.rows });
    if (props.admin.currentPage !== 1) {
      window.scroll({
        top: containerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    if (props.admin.paginationBasicFirst > 0) {
      window.scroll({
        top: containerRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  }, [props.admin.paginationBasicFirst]);

  const getListOfUsers = () => {
    return isFiltered ? usersFiltered : users;
  };
  const getRoles = (user) => {
    const roles = [];
    for (let i = 0; i < user.length; i++) {
      roles.push({ roleName: user[i].role_name, endAt: user[i].end_at });
    }
    return roles;
  };
  return (
    <div className="contributeurs">
      <h3 className="contributeurs__title">Liste des contributeurs</h3>
      <div className="contributeurs__form">
        <div className="contributeurs__form__champ">
          <label>Prénom</label>
          <InputText
            value={firstname}
            placeholder="Marie, Paul..."
            onChange={(e) => setFirstname(e.target.value)}
          />
        </div>
        <div className="attribuerDroits__form__champ">
          <label>Nom</label>
          <InputText
            value={surname}
            placeholder="Dupont, Gary..."
            onChange={(e) => setSurname(e.target.value)}
          />
        </div>
        <div className="attribuerDroits__form__champ">
          <label>Filtrer par droit</label>
          <Dropdown
            id="roles"
            placeholder="Filtrer par droit"
            value={roleToFind}
            optionLabel="name"
            onChange={(e) => setRoleToFind(e.value)}
            options={rolesData}
          />
        </div>
      </div>
      <BtnBleu btnTexte="Rechercher" btnAction={() => handleRecherche()} />
      <div ref={containerRef}>
        {users.length > 0 ? (
          <>
            {getListOfUsers()
              .slice(
                props.admin.paginationBasicFirst,
                props.admin.paginationBasicRows * props.admin.currentPage
              )
              .map((user, index) => (
                <>
                  <MembreCard
                    currentRole={user[0].current_role}
                    key={index}
                    dejaRole={true}
                    nom={user[0].surname}
                    prenom={user[0].firstname}
                    roles={getRoles(user)}
                    rolesFromDb={props.rolesFromDb}
                    userId={user[0].id}
                    handleRecherche={() => handleGetUsers()}
                  />
                </>
              ))}
            <Paginator
              first={props.admin.paginationBasicFirst}
              pageLinkSize={screen.width <= 830 ? 1 : 3}
              rows={props.admin.paginationBasicRows}
              totalRecords={isFiltered ? usersFiltered.length : users.length}
              leftContent={"Page précédente"}
              rightContent={"Page suivante"}
              onPageChange={onBasicPageChange}
            />
          </>
        ) : (
          <p>
            Aucun utilisateur n&apos;a le rôle validation d&apos;offres ou de
            rédacteur d&apos;actualités
          </p>
        )}
      </div>
    </div>
  );
};

Contributeurs.propTypes = {
  handleUpdatePagination: PropTypes.func,
  admin: PropTypes.object,
  auth: PropTypes.object,
  rolesFromDb: PropTypes.array,
};
const mapStateToProps = (state) => ({
  admin: state.admin,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdatePagination: (value) => dispatch(updateAdmin(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Contributeurs);
